/**
 * NGXS actions for the AuthState.
 *
 * Each user-facing auth flow is represented by a "Submit" action that
 * triggers an API call, followed by a Success/Failure action dispatched
 * from the state's action handler. Components subscribe to the store for
 * feedback rather than calling AuthService directly so that state
 * remains the single source of truth.
 */
export namespace AuthActions {
  export class SubmitLogin {
    static readonly type = '[Auth] Submit Login';
    constructor(public email: string, public password: string) {}
  }

  export class LoginSuccess {
    static readonly type = '[Auth] Login Success';
    constructor(public user_id: number, public api_id: string, public email: string) {}
  }

  export class LoginFailure {
    static readonly type = '[Auth] Login Failure';
    constructor(public status: string) {}
  }

  export class SubmitRegister {
    static readonly type = '[Auth] Submit Register';
    constructor(public email: string, public password: string) {}
  }

  export class RegisterSuccess {
    static readonly type = '[Auth] Register Success';
  }

  export class RegisterFailure {
    static readonly type = '[Auth] Register Failure';
    constructor(public status: string) {}
  }

  export class SubmitResetPassword {
    static readonly type = '[Auth] Submit Reset Password';
    constructor(public email: string, public newPassword: string) {}
  }

  export class ResetPasswordSuccess {
    static readonly type = '[Auth] Reset Password Success';
  }

  export class ResetPasswordFailure {
    static readonly type = '[Auth] Reset Password Failure';
    constructor(public status: string) {}
  }

  export class SubmitResendActivation {
    static readonly type = '[Auth] Submit Resend Activation';
    constructor(public email: string, public password: string) {}
  }

  export class ResendActivationSuccess {
    static readonly type = '[Auth] Resend Activation Success';
  }

  export class ResendActivationFailure {
    static readonly type = '[Auth] Resend Activation Failure';
    constructor(public status: string) {}
  }

  /** Clears auth state and any user-scoped local caches. */
  export class Logout {
    static readonly type = '[Auth] Logout';
  }

  /** Clears the most recent error so the form can be resubmitted. */
  export class ClearError {
    static readonly type = '[Auth] Clear Error';
  }
}
